var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1335 36.7333H27.8668M19.0002 36.7333V24.0666M19.0002 24.0666C24.5967 24.0666 29.1335 19.5298 29.1335 13.9333V3.79993C29.1335 2.40081 27.9993 1.2666 26.6002 1.2666H11.4002C10.0011 1.2666 8.86684 2.40081 8.86684 3.79993V13.9333C8.86684 19.5298 13.4037 24.0666 19.0002 24.0666ZM8.86684 6.33327H6.33351C3.53527 6.33327 1.26685 8.60169 1.26685 11.3999C1.26685 14.1982 3.53527 16.4666 6.33351 16.4666H8.86684M29.1335 6.33327H31.6668C34.4651 6.33327 36.7335 8.60169 36.7335 11.3999C36.7335 14.1982 34.4651 16.4666 31.6668 16.4666H29.1335",
    stroke: "#275EAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.6f342338d228784f6f3c9241682bc658.svg";
export { ForwardRef as ReactComponent };